import { Container, Text } from './styles'

export const Title = (props) => {

  return (
   <Container>
    <Text>{props.children}</Text>
   </Container>
  )
}